import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()

//Industry type- admin panel
export const getIndustry = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/Industry`, config)
  }

//job type- admin panel
export const getJobType  = async(abortToken)=>{
  const config = {
      ...abortToken,
      timeout: 30000, // Set the timeout for this specific request
    };
  return  await api.get(`/JobType`, config)
}
